module.exports = {
  owner: "f142ef84-3383-4f16-9dd0-eb26f0d02c65",
  id: "943d45d1-3361-4abd-8b64-62876aa2054d",
  account: "EURO",
  details: {
    AddressLine2: "Brno CZ Czech Republic",
    AddressLine1: "Kamenickova 1114 2 Zabovresky 616 01",
    Currency: "EUR",
    CreditorType: "Organisation",
    AccountIdentifier: "GB17CLJU00997129900158",
    "Beneficiary Name": "Company Ltd.",
    CountryCode: "GB",
    BankIdentifier: "CLJUGB21",
  },
  transfer_type: "SEPA",
};
